'use strict'
import api from '@/api/api'
import notify from '@/utils/notify'

export default {
  async list(params = {}) {
    const query = new URLSearchParams(params).toString()
    const url = query ? `review-criteria?${query}` : 'review-criteria'
    const data = { method: 'get', url }
    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return []
  },

  async create(json) {
    const data = { method: 'post', url: 'review-criteria', body: json }
    const response = await api.api(data)
    if (response.status === 201 || response.status === 200) {
      notify.alert.success('Review criteria created successfully')
      return response.data
    }
  },

  async get(id) {
    const data = { method: 'get', url: `review-criteria/${id}` }
    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },

  async update(id, json) {
    const data = { method: 'patch', url: `review-criteria/${id}`, body: json }
    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Review criteria updated successfully')
      return response.data
    }
  },

  async destroy(id) {
    const data = { method: 'delete', url: `review-criteria/${id}` }
    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Review criteria deleted successfully')
      return true
    }
  }
}
